// extracted by css-extract-rspack-plugin
export default {"cls1":"Filter-cls1_WYW","cls2":"Filter-cls2_K4e Filter-cls1_WYW"};